import script from "./CommonPlanMethodCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonPlanMethodCard.vue?vue&type=script&lang=ts&setup=true"

import "./CommonPlanMethodCard.vue?vue&type=style&index=0&id=104bf39b&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104bf39b"]])

export default __exports__